import { Badge } from 'V2.0/common/badge'

const STATUS_LABEL = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected'
}

const STATUS_LABEL_COLORS = {
  PENDING: 'amber',
  APPROVED: 'green',
  REJECTED: 'red'
}

export default function TemplateStatusBadge({ status }) {
  return <Badge color={STATUS_LABEL_COLORS[status]}>{STATUS_LABEL[status]}</Badge>
}
